var map = {
	"./bg-parcking.svg": [
		"./src/images/bg-parcking.svg?6e0b",
		"src_images_bg-parcking_svg"
	],
	"./bg.svg": [
		"./src/images/bg.svg"
	],
	"./decoration.svg": [
		"./src/images/decoration.svg?5410"
	],
	"./logo-black.svg": [
		"./src/images/logo-black.svg?2f1d",
		"src_images_logo-black_svg"
	],
	"./logo.svg": [
		"./src/images/logo.svg?6073",
		"src_images_logo_svg"
	],
	"./p3.svg": [
		"./src/images/p3.svg",
		"src_images_p3_svg"
	],
	"./p4.svg": [
		"./src/images/p4.svg",
		"src_images_p4_svg"
	],
	"./p5.svg": [
		"./src/images/p5.svg",
		"src_images_p5_svg"
	],
	"./p6.svg": [
		"./src/images/p6.svg",
		"src_images_p6_svg"
	],
	"./p7.svg": [
		"./src/images/p7.svg",
		"src_images_p7_svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/images lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;